<template>
    <ul class="u-mb-3 u-d-flex u-justify-content-center u-pl-0">
        <SessionSelectItem v-for="(item, index) in internalSessions" :key="item.id" :item="item" :index="index" :selected="item.selected" @selected="setSelected"/>
    </ul>
</template>

<script>
import SessionSelectItem from './SessionSelectItem';
import Vue from 'vue';
export default {
    name: 'SessionSelect',
    props: ['sessions'],
    components: {
        SessionSelectItem
    },
    methods: {
        setSelected(index) {
            for(let i = 0; i < this.internalSessions.length; i++) {
                Vue.set(this.internalSessions[i], 'selected', false);
            }
            Vue.set(this.internalSessions[index], 'selected', true);
            this.$emit('selected', this.internalSessions[index]);
        }
    },
    data() {
        return {
            internalSessions: []
        }
    },
    watch: {
        sessions: function(newSessions, oldSessions) {
            let tmp = []
            for(let i = 0; i < newSessions.length; i++) {
                tmp.push(newSessions[i]);
            }

            this.internalSessions = tmp;
        }
    }
}
</script>

<style>

</style>
